module.exports = require("@noble/hashes/hmac");